import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { getBorder } from 'Components/utils';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import FooterContentPicker from './FooterContentPicker';

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
    background: theme.palette.common.white,
    gap: theme.spacing(2),
    ...getBorder(theme, { top: true, color: theme.palette.facet.lightGray }),
  },
});

const Footer = ({
  className,
  classes,
}) => {
  const { pageContentResource } = usePageContentContext();

  return (
    <Box className={classNames(classes.root, className)}>
      <FooterContentPicker resource={pageContentResource} />
    </Box>
  );
};

Footer.defaultProps = {
  className: '',
};

Footer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
